<script lang="ts">
  export let checked: boolean = false;
  export let disabled: boolean = false;
  export let variant: "default" | "circle" = "default";

  let clazz: string = "";
  export { clazz as class };
</script>

<label class="inline-flex items-start {clazz}" class:cursor-pointer={!disabled}>
  <input
    class="text-brand-green focus:ring-0 focus:ring-offset-0 focus-visible:ring focus-visible:ring-brand-green/50 bg-white/10 border border-white/80"
    class:circle={variant === "circle"}
    class:default={variant === "default"}
    class:cursor-pointer={!disabled}
    type="checkbox"
    {disabled}
    bind:checked
    on:change
  />
  <span class="ml-2 self-center">
    <slot />
  </span>
</label>

<style lang="postcss">
  .default {
    @apply rounded my-1;
  }
  .circle {
    @apply rounded-full my-[3px] w-4 h-4;
  }

  input[type="checkbox"]:disabled {
    @apply bg-white/[2%] border-white/30;
  }

  input[type="checkbox"]:not(:checked):not(:disabled):hover {
    @apply bg-primary/20 border-primary;
  }

  /* The @tailwindcss/forms plugin adds a white checkmark to all checkboxes. This makes the checkmark black */
  input[type="checkbox"]:checked {
    background-image: url("data:image/svg+xml,%3csvg%20viewBox='0%200%2016%2016'%20fill='black'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M12.207%204.793a1%201%200%20010%201.414l-5%205a1%201%200%2001-1.414%200l-2-2a1%201%200%20011.414-1.414L6.5%209.086l4.293-4.293a1%201%200%20011.414%200z'/%3e%3c/svg%3e");
  }
</style>
